/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import Vue from 'vue';
import Router from 'vue-router';

// Route level code-splitting
//
// The following generates a separate chunk ([name].[hash].js) for each route which is lazy-loaded
// when the route is visited.
const home = () => import(/* webpackChunkName: "home" */ '@/pages/Home.vue');
const product = () => import(/* webpackChunkName: "product" */ '@/pages/Product.vue');
const cart = () => import(/* webpackChunkName: "cart" */ '@/pages/Cart.vue');
const checkout = () => import(/* webpackChunkName: "cart" */ '@/pages/Checkout.vue');

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { name: 'home', path: '/', component: home, meta: { withFixedTopNav: true } },
    { name: 'product', path: '/p/:productVariantId', component: product },
    { name: 'cart', path: '/cart', component: cart },
    { name: 'checkout', path: '/checkout/:draftOrderId', component: checkout },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});
